import React, { type FC, memo, useCallback, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDuplicatesAnalytic } from 'reactApp/hooks/duplicates/useDuplicatesAnalytic';
import { getDuplicatesGroupsTotal, getDuplicatesPreviewItems } from 'reactApp/modules/duplicates/duplicates.selectors';
import { AlbumLabel } from 'reactApp/ui/AlbumLabel/AlbumLabel';
import { DuplicatesPreviewVariant2 } from 'reactApp/ui/Duplicates/DuplicatesPreview/DuplicatesPreviewVariant2/DuplicatesPreviewVariant2';
import { DuplicatesPreviewVariant3 } from 'reactApp/ui/Duplicates/DuplicatesPreview/DuplicatesPreviewVariant3/DuplicatesPreviewVariant3';
import { DuplicatesPreviewVariant4 } from 'reactApp/ui/Duplicates/DuplicatesPreview/DuplicatesPreviewVariant4/DuplicatesPreviewVariant4';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

import styles from './DuplicatesPreview.css';

enum DuplicatesPreviewCount {
    two = 2,
    three = 3,
    four = 4,
}

export const DuplicatesPreview: FC = memo(function DuplicatesPreview() {
    const previewItems = useSelector(getDuplicatesPreviewItems);
    const duplicatesTotal = useSelector(getDuplicatesGroupsTotal);
    const analyticData = useDuplicatesAnalytic();

    useEffect(() => {
        sendPaymentGa({ eventCategory: ECategoryGa.duplicates, action: 'compilation-show', ...analyticData });
    }, []);

    const label = useMemo(
        () => (
            <AlbumLabel className={styles.label} qaLabel="title">
                <>Дубликаты • {duplicatesTotal}</>
            </AlbumLabel>
        ),
        [duplicatesTotal]
    );

    const onClick = useCallback(() => {
        sendPaymentGa({ eventCategory: ECategoryGa.duplicates, action: 'compilation-click', ...analyticData });
    }, [analyticData]);

    if (previewItems.length === DuplicatesPreviewCount.two) {
        return (
            <DuplicatesPreviewVariant2
                rootClassName={styles.root}
                imgClassName={styles.img}
                label={label}
                items={previewItems}
                onClick={onClick}
            />
        );
    }

    if (previewItems.length === DuplicatesPreviewCount.three) {
        return (
            <DuplicatesPreviewVariant3
                rootClassName={styles.root}
                imgClassName={styles.img}
                label={label}
                items={previewItems}
                onClick={onClick}
            />
        );
    }

    return (
        <DuplicatesPreviewVariant4
            rootClassName={styles.root}
            imgClassName={styles.img}
            label={label}
            items={previewItems}
            onClick={onClick}
        />
    );
});
